// eslint-disable-next-line unused-imports/no-unused-imports
import { useNextgenRouter } from '@nextgen-web-framework/all';
import { LoginState } from './types/enums';

export const getLoginProps = (router: ReturnType<typeof useNextgenRouter>) => {
  const tuples = ApiConfigService.getTuples();
  const configs = ConfigService.getConfigs();
  let postAuthUrl = '';
  if (typeof window !== 'undefined') {
    const loginState: LoginState = {
      redirectUri: `${configs.NEXT_PUBLIC_WEB_BASE_PATH}${router.pathname}`,
      headers: tuples,
      amwayLang: router.params?.locale as string,
    };

    if (configs.NEXT_PUBLIC_LOGIN_URL) {
      loginState.loginUrl = configs.NEXT_PUBLIC_LOGIN_URL as string;
    }
    postAuthUrl = btoa(JSON.stringify(loginState));
  }
  return {
    scope: 'openid',
    state: postAuthUrl,
    countryIso: tuples['X-Amway-Country'],
    redirectUri: configs.NEXT_PUBLIC_OIDC_URL ? `${configs.NEXT_PUBLIC_OIDC_URL}` : '',
  };
};

export const getSignUpUrl = () => {
  const configs = ConfigService.getConfigs();
  const redirectUrl = configs.NEXT_PUBLIC_REGISTER_REDIRECT_URL ?? '/complete-your-profile';
  return `/signup?flowName=${configs.NEXT_PUBLIC_REGISTER_FLOW}&returnUri=${redirectUrl}`;
};
